import Vue from 'vue'
import Router from 'vue-router'
import home from '@/components/home'
import login from '@/components/login'
import exit from '@/components/exit'
import createOrder from '@/components/createOrder'
import orderDetail from '@/components/orderDetail'
import assignationManagement from '@/components/assignationManagement'
import car from '@/components/car'
import lineItem from '@/components/lineItem'
import siteList from '@/components/siteList'
import billList from '@/components/billList'
import order from '@/components/selfhelp/order'
import therefuel from '@/components/selfhelp/therefuel'

Vue.use(Router)

const myRouter = new Router({
    mode: 'hash',
    routes: [
        {path: '/', name: 'home', component: home},
        {path: '/login', name: 'login', component: login},
        {path: '/sitelist', name: 'siteList', component: siteList},
        {path: '/exit', name: 'exit', component: exit},
        {path: '/createOrder/:id', name: 'createOrder', component: createOrder},
        {path: '/orderDetail/:order_id', name: 'orderDetail', component: orderDetail},
        {path: "/assignationManagement/:card_obj", name: "assignationManagement", component: assignationManagement},
        {path: "/lineItem", name: "lineItem", component: lineItem},
        {path: "/car", name: "car", component: car},
        {path: "/billList", name: "billList", component: billList},
        {path: "/selfhelp/order/:gun_num", name: "selfHelpOrder", component: order},
        {path: "/selfhelp/therefuel/:facility", name: "selfHelpTherefuel", component: therefuel},
    ]
});

myRouter.beforeEach((to, from, next) => {
    if (to.query.abc) {
        next();
        return;
    }
    ;
    if (from.query.abc) {
        let toQuery = JSON.parse(JSON.stringify(to.query));
        toQuery.abc = from.query.abc;
        next({
            path: to.path,
            query: toQuery
        })
    } else {
        to.query.abc = 123
        next()
    }
});
export default myRouter



// WEBPACK FOOTER //
// ./src/router/index.js